"use client"

import { BaseModal } from "@/components/BaseModal"
import { ExperienceItem } from "@/data/experience"
import { useLocale } from "next-intl"

type ExperienceModalProps = {
  item: ExperienceItem
  itemIndex: number
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Experience Modal Component
 * 
 * Uses the standardized BaseModal with experience-specific settings
 */
export default function ExperienceModal({ item, /* itemIndex, */ open, onOpenChange }: ExperienceModalProps) {
  const locale = useLocale()
  
  return (
    <BaseModal
      item={{
        title: item.name,
        image: item.image,
        imageDark: item.imageDark,
        website: item.website,
        subtitle: item.role,
        description: item.description,
        date: item.period,
        tags: item.tags,
        displayTags: item.displayTags,
        references: item.references
      }}
      open={open}
      onOpenChange={onOpenChange}
      locale={locale}
    />
  )
}